/**
 * API base URL: the same NetKeep API the mobile app uses. Fixed at build time with
 * VITE_API_URL (see .env.example); users cannot change it in the app.
 *
 * Only public, non-secret configuration may live here: everything in a VITE_
 * variable is embedded in the JavaScript bundle.
 */
export const DEFAULT_API_URL = import.meta.env.VITE_API_URL?.trim() || "https://netkeep-api.onrender.com";
// Local API (run `npm run dev` in the netkeep-api repo): swap with the line above, or set
// VITE_API_URL=http://localhost:3000 in .env.local.
// export const DEFAULT_API_URL = import.meta.env.VITE_API_URL?.trim() || "http://localhost:3000";

export const DEFAULT_REGION = "US";
export const DEFAULT_CURRENCY = "USD";
export const REQUEST_TIMEOUT_MS = 8000;
export const APP_VERSION = __APP_VERSION__;
